import { NgModule } from '@angular/core';
import { CopyToClipboardDirective } from '@go-modules/directives/go-clipboard/copy-to-clipboard.directive';
import {
	CopyToClipboardWrapperComponent
} from '@go-modules/directives/go-clipboard/copy-to-clipboard-wrapper/copy-to-clipboard-wrapper.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		MatTooltipModule
	],
	declarations: [
		CopyToClipboardDirective,
		CopyToClipboardWrapperComponent
	],
	exports: [
		CopyToClipboardDirective,
		CopyToClipboardWrapperComponent
	]
})
export class CopyToClipboardDirectiveModule {}
